import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import AddStudentForm from 'modules/students/components/AddStudentForm'
import { fetchTeachersListRoutine } from 'modules/teachers/ducks/actions'
import { useDispatch } from 'react-redux'
import { fetchSchoolSubjectsRoutine } from 'modules/settings/ducks/actions'
import { getActiveStudentsRoutine } from 'modules/students/ducks/actions'
import StudentsTable from 'modules/students/components/StudentsTable'
import ExpandablePanel from 'components/ExpandablePanel'
import PaymentsFromFileModal from 'modules/students/components/PaymentsFromFileModal'
import Button from 'components/Button'

const Students = () => {
  const dispatch = useDispatch()
  const [paymentsModalOpen, setPaymentsModalOpen] = useState(false)

  useEffect(() => {
    dispatch(fetchTeachersListRoutine())
    dispatch(fetchSchoolSubjectsRoutine())
    dispatch(getActiveStudentsRoutine())
  }, [])

  return (
    <div>
      <HeaderRow>
        <PageHeader>Uczniowie</PageHeader>
        <Button
          color='primary-outline'
          onClick={() => setPaymentsModalOpen(true)}
          style={{ width: '200px' }}
        >
          Wpłaty z pliku
        </Button>
      </HeaderRow>
      <PaymentsFromFileModal
        open={paymentsModalOpen}
        onClose={() => setPaymentsModalOpen(false)}
      />
      <AddStudentForm callback={() => dispatch(getActiveStudentsRoutine())} />
      <ExpandablePanel startOpen title='Lista uczniów'>
        <StudentsTable />
      </ExpandablePanel>
    </div>
  )
}

export default Students

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

const PageHeader = styled.div`
  font-size: 24px;
`
